import { stripSpacesAndDashesFromInput } from './stripSpacesAndDashesFromInput';
/**
 * Find email in strings.
 * Regex is pretty greedy, but preferred than a complex regexp. Rather have too much filtered than not.
 *
 * This package doesn't use the validation package (@anwb/email), as matching is too precise. Greedy matching is preferred due to
 * GDPR fees and possible permanent closure of our Analytics Accounts.
 */
export function isEmailAddress(input) {
    const cleanedInput = stripSpacesAndDashesFromInput(input);
    const regexp = new RegExp(/\S+@\S+\.\S+$/gi);
    return regexp.test(cleanedInput);
}
